import PropTypes from 'prop-types';
import React from 'react';
import { Button, Image } from 'react-bootstrap';

export function checkForNeedUpgrade(perms) {
  let needUpgrade = true;
  perms.forEach((perm) => {
    if (perm === 'hotel_paid') {
      needUpgrade = false;
    }
  });
  return needUpgrade;
}

class UpgradeAccount extends React.Component {
  onClick = () => {
    this.props.joinWaitlist();
  }
  render() {
    if (this.props.waitlistisFetching) {
      return null;
    }
    if (this.props.onWaitlist) {
      return (
        <div className="container">
          <div className="row">
            <div className="planner col-sm-12">
              <h1>Thanks for requesting early access</h1>
              <p>We will be in touch soon!</p>
              <Image src="https://storage.googleapis.com/app_usecatch_com/static/stadium_crowd.jpg" responsive />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="container">
        <div className="row">
          <div className="planner col-sm-12">
            <h1>Want to stand out from the competition?</h1>
            <p>The top entertainment tours are booked on Catch. Make sure your property is ready to welcome them in 2018.</p>
            <p>Catch Hotel Member features include:</p>
              <ul>
                <li>Managed property listings with photos, sales contacts and all entertainment related info</li>
                <li>Highlighted property in search results</li>
                <li>Ability to send targeted special group offers</li>
                <li>Group booking data</li>
                <li>And more!</li>
              </ul>
            <p>Space is limited, join the waitlist now.</p>
            <p>
              <Button bsStyle="info" onClick={this.onClick}>Request Early Access</Button>
            </p>
            <Image src="https://storage.googleapis.com/app_usecatch_com/static/stadium_crowd.jpg" responsive />
          </div>
        </div>
      </div>
    );
  }
}
export default UpgradeAccount;



// WEBPACK FOOTER //
// src/routes/hotels/components/UpgradeAccount.js